import Vue from "vue";
import axios from "axios";
import "../../filters";
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";
import VueFormGenerator from "vue-form-generator";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-form-generator/dist/vfg.css";
import DxDateBox from "devextreme-vue/date-box";
import { DxTextBox, DxCheckBox, DxNumberBox } from "devextreme-vue";
import DxRadioGroup from "devextreme-vue/radio-group";
import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager,
} from "devextreme-vue/data-grid";

const uiDateFormat = "DD/MM/YYYY";

export default {
  name: "RSession",
  components: {
    DxRadioGroup,
    DxTextBox,
    DxCheckBox,
    DxNumberBox,
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager,
    DxDateBox,
    FormWizard,
    TabContent,
    RSessionDataComp: require("./rSessionData.vue").default,
  },
  data: function () {
    return {
      fileImportProcess: { completed: false, success: false, response: null },
      fileImportFormat: null,
      externalReceiptWindow: false,
      externalReceipt: { file: null, filePagesObj: null, fileId: null },
      acceptedFormats: ".txt,.csv,.xls,.xlsx",
      pageSelected: null,

      emptySearchResults: null,
      bSessionDetails: false,
      bDisabledButtons: true,
      bAutoExpand: true,
      allowColumnReordering: true,
      allowColumnResizing: true,
      columnAutoWidth: true,
      stateSortingEnabled: false,
      showSessionDialog: false,
      bUpdateSessionDialog: false,
      bAuthorizeSessionDialog: false,
      bUnblockSessionDialog: false,
      bCancelSessionDialog: false,
      focusedRowKey: "",
      bankRef: "",

      uiKey: 0,

      summaryColumn: "",

      dateFrom: null,
      dateTo: new Date(),
      cashiers: [],
      cashier: "",
      rSessions: [],
      rSession: "",
      rSessionB4Selected: "",
      rSessionCount: 0,
      completed: false,
      fileImportFormats: [],
      receiptingAllowUnblockSession: false,
      allowReceiptingAuthSession: false,
      allowAuthOwnSession: false,
      bIsSessionSelected: false,

      rtl: false,

      reports: [],
      cols: [],

      lang: "",
      keyColumn: "sessionId",

      reportUrl: "",
      filter: "",
      options: { pageSize: 10, total: 0, page: 1 },
    };
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
    GetSummaryColumnName: function () {
      return this.summaryColumn || Object.keys(this.rSessions[0])[0];
    },
    importPageReady: function () {
      return (
        this.externalReceipt.fileId &&
        this.fileImportFormat &&
        this.pageSelected &&
        this.pageSelected.index >= 0
      );
    },
  },
  watch: {
    languageLocale: function (value) {},
  },
  async created() {
    await this.getSettings();
    this.fillCols();
    var d = new Date();
    d.setMonth(d.getMonth() - 12);
    this.dateGenerated = d;
    this.getSettings();
  },
  methods: {
    sessionDetails() {
      this.bSessionDetails = true;
    },
    formatMoney(number, decPlaces, decSep, thouSep) {
      (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
        (decSep = typeof decSep === "undefined" ? "." : decSep);
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(
        parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
      );
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces
          ? decSep +
            Math.abs(number - parseInt(i))
              .toFixed(decPlaces)
              .slice(2)
          : "")
      );
    },
    getSettings() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      return axios
        .get("/ReceiptingSession/GetSettings")
        .then((response) => {
          if (response.status == 200) {
            this.cashiers = [
              {
                cashierId: "All",
                name: "All",
              },
              ...response.data.cashiers,
            ];

            this.cashier = this.cashiers[0];
            this.getSessions();

            this.fileImportFormats = response.data.fileImportFormats;
            this.fileImportFormat = response.data.fileImportFormats[0];
            this.receiptingAllowUnblockSession =
              response.data.receiptingAllowUnblockSession;
            this.allowReceiptingAuthSession =
              response.data.allowReceiptingAuthSession;
            this.allowAuthOwnSession = response.data.allowAuthOwnSession;
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    sessionParameter(sessionId, bankRef) {
      let parameter = "sessionId=" + sessionId;
      if (bankRef) parameter = parameter + "&bankRef=" + bankRef;

      return parameter;
    },
    unblockSession() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/ReceiptingSession/UnblockSession",
          this.sessionParameter(this.rSession.sessionId, this.bankRef)
        )
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.SessionUnblockSuccess"), 2);
            this.bankRef = "";
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    cancelExternalSession() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/ReceiptingSession/CancelExternalReceiptsSession",
          this.sessionParameter(this.rSession.sessionId, this.bankRef)
        )
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.SessionCancelSuccess"), 2);
            this.bankRef = "";
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    authorizeSession() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/ReceiptingSession/AuthoriseSession",
          this.sessionParameter(this.rSession.sessionId, this.bankRef)
        )
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.SessionAuthSuccess"), 2);
            this.bankRef = "";
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    updateSession() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/ReceiptingSession/UpdateSession",
          this.sessionParameter(this.rSession.sessionId, this.bankRef)
        )
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t("messages.SessionUpdatedSuccess"), 2);
            this.bankRef = "";
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    getSessions() {
      var parameter = `cashierId=${
        this.cashier &&
        this.cashier.cashierId &&
        this.cashier.cashierId != "All"
          ? this.cashier.cashierId
          : ""
      }&completed=${this.completed}&dateFrom=''&dateTo=''&filter=${
        this.filter
      }&pageIndex=${this.options.page}&pageSize=${this.options.pageSize}`;
      if (this.dateFrom)
        parameter = parameter + new Date(this.dateFrom.toDateString());
      if (this.dateTo)
        parameter = parameter + new Date(this.dateTo.toDateString());

      this.rSessions = [];
      this.bIsSessionSelected = false;
      this.bDisabledButtons = true;

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/ReceiptingSession/GetSessions?" + parameter)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.items.length == 0) this.emptySearchResults = true;
            else this.emptySearchResults = false;

            response.data.items.forEach((item) => {
              item.sessionDate = item.sessionDate
                ? moment(item.sessionDate).format("DD/MM/YYYY HH:MM")
                : null;
              item.authDateTime = item.authDateTime
                ? moment(item.authDateTime).format("DD/MM/YYYY HH:MM")
                : null;
            });
            this.bIsSessionSelected = false;
            this.rSessions = response.data.items;
            this.options.total = response.data.totalCount;
            this.rSessionCount = response.data.totalCount;
            setTimeout(
              function () {
                if (document.getElementById("gridSessions"))
                  document
                    .getElementById("gridSessions")
                    .scrollIntoView({ block: "start", behavior: "smooth" });
              }.bind(this),
              500
            );
          } else this.emptySearchResults = null;

          loader.hide();
        })
        .catch((error) => {
          this.emptySearchResults = null;
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    resetFilters() {
      this.cashier = "";
      this.filter = "";
      this.rSessions = [];
      this.bIsSessionSelected = false;
      var d = new Date();
      d.setMonth(d.getMonth() - 12);
      this.dateFrom = d;
      this.dateTo = new Date();
      if (this.cashiers.length > 0) this.cashier = this.billingGroups[0];
    },
    getCellClass(value) {
      var rc = "";

      switch (value) {
        case "Open":
          rc = "recordTypeGreen";
          break;
        case "Posted":
          rc = "recordTypeBlue";
          break;
        case "Forced closed":
          rc = "recordTypeBlack";
          break;
        case "Suspended":
          rc = "recordTypeOrange";
          break;
        case "Completed":
          rc = "recordTypeCream";
          break;
        case "Voided":
          rc = "recordTypeRed";
          break;
        case "Transferring":
          rc = "recordTypeCream";
          break;
        default:
          rc = "recordTypeBlack";
      }

      return rc;
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      //this.getCustomers();
    },
    fillCols() {
      this.cols.push({
        dataField: "sessionId",
        width: 70,
        visible: true,
        caption: this.$t("rSessions.sessionId"),
      });
      this.cols.push({
        dataField: "sessionDate",
        visible: true,
        caption: this.$t("rSessions.sessionDate"),
      });
      this.cols.push({
        dataField: "cashierId",
        width: 60,
        visible: true,
        caption: this.$t("rSessions.cashierId"),
      });
      this.cols.push({
        dataField: "cashierName",
        width: 200,
        caption: this.$t("rSessions.cashierName"),
      });
      this.cols.push({
        dataField: "amount",
        alignment: "right",
        width: 90,
        caption: this.$t("rSessions.amount"),
      });
      this.cols.push({
        dataField: "status",
        width: 100,
        cellTemplate: "cellTemplate",
        caption: this.$t("rSessions.status"),
      });
      this.cols.push({
        dataField: "type",
        width: 160,
        caption: this.$t("rSessions.sessionType"),
      });
      this.cols.push({
        dataField: "lastReceipt",
        visible: true,
        caption: this.$t("rSessions.lastReceipt"),
      });
      this.cols.push({
        dataField: "receiptFrom",
        visible: true,
        caption: this.$t("rSessions.receiptFrom"),
      });
      this.cols.push({
        dataField: "receiptTo",
        visible: true,
        caption: this.$t("rSessions.receiptTo"),
      });
      this.cols.push({
        dataField: "authDateTime",
        caption: this.$t("rSessions.authDateTime"),
      });
      this.cols.push({
        dataField: "authUser",
        caption: this.$t("rSessions.authUser"),
      });
    },
    chooseSession(info) {
      if (info.newRowIndex < 0) return;

      var currentSession = info.rows[info.newRowIndex].data;
      if (currentSession === null || currentSession === undefined) return;

      this.rSessionB4Selected = currentSession;
      this.showSessionDialog = true;
    },
    goCancelSession() {
      this.bCancelSessionDialog = false;
      this.cancelExternalSession();
    },
    goUnblockSession() {
      this.bUnblockSessionDialog = false;
      this.unblockSession();
    },
    goAuthorizeSession() {
      ``;
      this.bAuthorizeSessionDialog = false;
      this.authorizeSession();
    },
    goUpdateSession() {
      this.bUpdateSessionDialog = false;
      this.updateSession();
    },
    selectSession() {
      this.rSession = this.rSessionB4Selected;

      this.showSessionDialog = false;
      this.bIsSessionSelected = true;
      this.bDisabledButtons = false;
      this.$root.$emit("session_data_updated");
    },
    cancelSession() {
      this.rSessionB4Selected = "";
      this.rSession = "";
      this.showSessionDialog = false;
      this.bIsSessionSelected = false;
    },
    validateCustomer(accountNo) {
      return axios.post(
        "/CustomerAgreement/ValidateCustomer?",
        "account=" + accountNo
      );
    },
    getReports() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/ReceiptingSession/GetReports")
        .then((response) => {
          if (response.status == 200) {
            this.reports = response.data.items;
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    addDays(date, days) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days
      );
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getUTCDate();

        date.setUTCMonth(date.getUTCMonth() + count, 1);
        m = date.getUTCMonth();
        date.setUTCDate(d);
        if (date.getUTCMonth() !== m) date.setUTCDate(0);
      }
      return date;
    },
    addMonths(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + count, 1);
        m = date.getMonth();
        date.setDate(d);
        if (date.getMonth() !== m) date.setDate(0);
      }
      return date;
    },
    formatDateUI(date) {
      return moment(date).add(1, "days").format(uiDateFormat);
    },
    roundNumberV2(value, decimals) {
      return Number(
        Math.round(Number(value + "e" + decimals)) + "e-" + decimals
      );
    },
    roundNumberV1(num, scale) {
      var arr = ("" + num).split("e");
      var sig = "";
      if (+arr[1] + scale > 0) {
        sig = "+";
      }
      var i = +arr[0] + "e" + sig + (+arr[1] + scale);
      var j = Math.round(Number(i));
      var k = +(j + "e-" + scale);
      return k;
    },
    onFocusedRowChanging: function (e) {
      var pageSize = e.component.pageSize(),
        pageIndex = e.component.pageIndex(),
        isLoading = e.component.getController("data").isLoading(),
        key = e.event && e.event.key;

      if (!isLoading) {
        if (key && e.prevRowIndex === e.newRowIndex) {
          if (e.newRowIndex === pageSize - 1) {
            e.component.pageIndex(pageIndex + 1).done(function () {
              e.component.option("focusedRowIndex", 0);
            });
          } else if (e.newRowIndex === 0) {
            e.component.pageIndex(pageIndex - 1).done(function () {
              e.component.option("focusedRowIndex", pageSize - 1);
            });
          }
        }
      }

      this.chooseSession(e);
    },
    onFocusedRowChanged: function (e) {
      //var info = e.row && e.row.data;
      //console.log(info);
      this.focusedRowKey = e.component.option("focusedRowKey");
    },
    onGridCellClick(info) {
      //console.log(info);
    },
    onGridRowDbClick(info) {
      //console.log(info);
    },

    openExternalReceiptWindow(open) {
      this.externalReceiptWindow = open;

      if (!open) {
        this.externalReceipt = {
          file: null,
          filePagesObj: null,
          fileId: null,
        };
        this.pageSelected = null;
        this.fileImportProcess = {
          completed: false,
          success: false,
          response: null,
        };
      }
    },
    onReceiptSelect(event) {
      const file = event.target.files[0];

      if (!file) return;

      const extension = file.name.split(".").pop().toLowerCase();

      if (!this.acceptedFormats.includes(extension)) {
        this.$oldAlertMsg(
          `Invalid file type. Only ${this.acceptedFormats} are allowed.`,
          3
        );
        this.externalReceipt = { file: null, filePagesObj: null, fileId: null };
        event.target.value = null;
        return;
      }

      const files = event.target.files;
      if (files && files.length > 0) {
        this.externalReceipt.file = files[0];
      }

      this.uploadFile();
    },
    uploadFile() {
      if (!this.externalReceipt.file) {
        return;
      }

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      const formData = new FormData();
      formData.append("file", this.externalReceipt.file);

      axios
        .post("/ReceiptingSession/UploadFile", formData)
        .then((resp) => {
          if (resp.status == 200) this.getPages(resp.data);
          else {
            this.externalReceipt = {
              file: null,
              filePagesObj: null,
              fileId: null,
            };
          }
        })
        .catch((err) => {
          this.externalReceipt = {
            file: null,
            filePagesObj: null,
            fileId: null,
          };
          this.$alertMsg(err, 4);
        })
        .finally(() => loader.hide());
    },
    getPages(fileId) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/ReceiptingSession/GetFilePages", { fileId })
        .then((resp) => {
          if (resp.status == 200) {
            this.externalReceipt = {
              ...this.externalReceipt,
              filePagesObj: resp.data,
              fileId,
            };
            this.pageSelected = resp.data[0];
          } else
            this.externalReceipt = {
              file: null,
              filePagesObj: null,
              fileId: null,
            };
          console.log("resp", resp);
        })
        .catch((err) => {
          this.externalReceipt = {
            file: null,
            filePagesObj: null,
            fileId: null,
          };
          this.$alertMsg(err, 4);
        })
        .finally(() => loader.hide());
    },
    importPage(fileId) {
      if (!this.importPageReady) {
        return;
      }

      let parameters = {
        FileId: this.externalReceipt.fileId,
        ImportFormat: this.fileImportFormat,
        PageIndex: this.pageSelected.index,
      };

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });

      axios
        .post("/ReceiptingSession/ImportPage", parameters)
        .then((resp) => {
          if (resp.status != 200) {
            // this.externalReceipt = { file: null, filePagesObj: null, fileId };
            this.fileImportProcess = {
              completed: true,
              success: true,
              response: resp.data,
            };
            // this.$alertMsg(resp.data.messages, 2);
          }
          console.log("resp", resp);
        })
        .catch((err) => {
          this.externalReceipt = {
            file: null,
            filePagesObj: null,
            fileId: null,
          };
          this.fileImportProcess = {
            completed: true,
            success: false,
            response: err.response.data,
          };
          // console.log(err.response.data);
          // this.$alertMsg(err.response.data ?? err, 4);
        })
        .finally(() => {
          loader.hide();
          // this.openExternalReceiptWindow(false);
        });
    },
  },
};
